import { Routes } from "@angular/router";
import { LoginComponent } from "./shared/components/login/login.component";
import { LoginSsoComponent } from "./shared/components/login/login-sso/login-sso.component";
import { ScheduledReportComponent } from "./shared/components/scheduled-report/scheduled-report.component";
import { NotFoundComponent } from "./shared/components/not-found/not-found.component";
import { authGuard } from "./shared/guards/auth/auth.guard";
import { authAdminGuard } from "./shared/guards/auth-admin/auth-admin.guard";
import { ForbiddenComponent } from "./shared/components/forbidden/forbidden.component";

export const routes: Routes = [
	{
		path: "",
		canActivate: [authGuard],
		loadChildren: () =>
			import("./curator/layout/curator-layout.routes").then(m => m.layoutCuratorRoutes)
	},

	{
		path: "admin",
		canActivate: [authAdminGuard],
		loadChildren: () =>
			import("./backoffice/layout/backoffice-layout.routes").then(m => m.layoutBackofficeRoutes)
	},
	{
		path: "login",
		component: LoginComponent
	},
	{
		path: "login-sso",
		component: LoginSsoComponent
	},
	{
		path: "scheduled-report/:savedReportId",
		component: ScheduledReportComponent
	},
	{
		path: "403",
		component: ForbiddenComponent
	},
	{ path: "**", component: NotFoundComponent }
];
